import type { APIClient } from '@src/shared/api';
import { prefetchQuery } from '@src/shared/query';
import { groupStatsUrl } from './constants';

export default function prefetchGroupStats(
  client: APIClient,
  userId: number,
) {
  prefetchQuery(groupStatsUrl, client, {
    queryParams: { user_id: String(userId) },
  });
}
